export enum ESashaPermissions {
    SASHA_BOOKING_SEARCH_AGENCY_AND_AGENT_LIST_SHOW = "sasha.booking.search.agencyAndAgent.list.show",
    SASHA_BOOKING_SEARCH_AGENCY_AND_AGENT_EXPERT_SHOW = "sasha.booking.search.agencyAndAgent.expert.show",
    SASHA_QUALITY_CHECK_SHOW= "sasha.qualityCheck.show",
    SASHA_BOOKING_SEARCH_PERSON_NOMEMBERSHIP_SHOW = "sasha.booking.search.person.noMemberShip.show",
    SASHA_BOOKING_SEARCH_SERVICE_NO_SEAT_ASSIGNMENT_SHOW = "sasha.booking.search.service.noSeatAssignment.show",
    SASHA_BOOKING_AIR_FARE_OPTIMISATION_USE = "sasha.booking.air.fare.optimisation.use",
}
